import axios from "axios";

export const handlerShareBtns = () => {
    $('.doLoadShareBtns').each(function () {
        axios.post($(this).data('url'), {
            entityId: $(this).data('entityId'),
            entityType: $(this).data('entityType')
        })
            .then((response) => {
                $(this).append(response.data.data);
            });
    });
};
